export default class StartWidget {
  startWidgetId!: number;
  brandId!: number;
  active!: boolean;
  // Button Display Options
  showLodgingButton!: boolean;
  showGolfButton!: boolean;
  showTransportationButton!: boolean;
  showExtrasButton!: boolean;
  showBookNowButton!: boolean;
  showSaveQuoteButton!: boolean;
  showQuickPackages!: boolean;
  // Itinerary Display Options
  showLodgingModule!: boolean;
  showGolfModule!: boolean;
  showTransportationModule!: boolean;
  showCustomItemsModule!: boolean;
  // Pricing Options
  showPerPersonPricing!: boolean;
  showTaxesTotal!: boolean;
  showGrandTotal!: boolean;
  showResortFeeTotal!: boolean;
  showCleaningFeeTotal!: boolean;
  showPromoCodeTotal!: boolean;
  // Vendor Rate Display Options In Cart
  showLodgingPricing!: boolean;
  showGolfPricing!: boolean;
  showTransportationPricing!: boolean;
  showCustomItemsPricing!: boolean;
  // Customer Requirements
  requireFirstLastName!: boolean;
  requireEmailAddress!: boolean;
  requirePhoneNumber!: boolean;
  requireAddress!: boolean;

  //Google Analytics
  activateGoogleAnalytics!: boolean;
  googleAnalyticsTrackingCode!: string;

  // this is not used currently
  googleTagImplementationCode!: string; // this is not used currently
  // Terms And Conditions
  requireTermsAndConditions!: boolean;
}

export const StartWidgetDefaults: StartWidget = {
  startWidgetId: 0,
  brandId: 0,
  active: false,
  //!Button Display Options
  showLodgingButton: false,
  showGolfButton: false,
  showTransportationButton: false,
  showExtrasButton: false,
  showBookNowButton: false,
  showSaveQuoteButton: false,
  showQuickPackages: false,
  //!Itinerary Display Options
  showLodgingModule: false,
  showGolfModule: false,
  showTransportationModule: false,
  showCustomItemsModule: false,
  //!Pricing Options
  showPerPersonPricing: false,
  showTaxesTotal: false,
  showGrandTotal: false,
  showResortFeeTotal: false,
  showCleaningFeeTotal: false,
  showPromoCodeTotal: false,
  //!Vendor Rate Display Options In Cart
  showLodgingPricing: false,
  showGolfPricing: false,
  showTransportationPricing: false,
  showCustomItemsPricing: false,
  //!Customer Requirements
  requireFirstLastName: false,
  requireEmailAddress: false,
  requirePhoneNumber: false,
  requireAddress: false,
  //!Google Analytics
  activateGoogleAnalytics: false,
  googleAnalyticsTrackingCode: "",
  googleTagImplementationCode: "",
  //!Terms And Conditions
  requireTermsAndConditions: false
}